<template>
  <div class="mt-14 px-14 text-center">
    <!-- Empty cart title skeleton -->
    <div class="mb-10 md:px-10">
      <div class="bg-light-charcoal-0.3 mx-auto h-6 w-64 animate-pulse rounded"></div>
    </div>

    <!-- Empty cart links skeleton -->
    <div v-if="showImages" class="mx-10 grid grid-cols-2 gap-x-2.5 gap-y-5">
      <div v-for="i in 4" :key="`image-${i}`" class="flex flex-col gap-2.5">
        <div class="bg-light-charcoal-0.3 aspect-8/10 size-full animate-pulse rounded-2xl"></div>
        <div class="px-1">
          <div class="bg-light-charcoal-0.3 mb-1 h-4 w-full animate-pulse rounded"></div>
          <div class="bg-light-charcoal-0.3 h-4 w-3/4 animate-pulse rounded"></div>
        </div>
      </div>
    </div>

    <!-- Empty cart buttons skeleton -->
    <div v-else class="flex w-full flex-col items-center gap-y-5">
      <div
        v-for="i in buttonCount"
        :key="`button-${i}`"
        class="btn btn-secondary bg-light-charcoal-0.3 min-h-[33px] w-full animate-pulse !border-none"
      ></div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  buttonCount: {
    default: 2,
    type: Number,
  },
  showImages: {
    default: false,
    type: Boolean,
  },
});
</script>
